import { CompletionMessage } from '@common/types/api/completionMessageTypes';

let messages: CompletionMessage[] = [];
const listeners = new Set<() => void>();

function notifyListeners() {
	listeners.forEach((listener) => listener());
}

function isCompletionMessage(value: unknown): value is CompletionMessage {
	if (!value || typeof value !== 'object') return false;
	const message = value as Partial<CompletionMessage>;
	return (
		(typeof message.id === 'number' || typeof message.id === 'string') &&
		typeof message.title === 'string' &&
		typeof message.body_html === 'string' &&
		typeof message.button_url === 'string'
	);
}

const completionMessages = {
	enqueue(message: unknown) {
		if (!isCompletionMessage(message) || messages.some(({ id }) => id === message.id)) return;
		messages = [...messages, { ...message }];
		notifyListeners();
	},
	close() {
		messages = messages.slice(1);
		notifyListeners();
	},
	getSnapshot(): CompletionMessage | null {
		return messages[0] ?? null;
	},
	subscribe(listener: () => void) {
		listeners.add(listener);
		return () => {
			listeners.delete(listener);
		};
	},
};

export default completionMessages;
